import { DEFAULT_ROLLUP_WEIGHT, weightedAverage } from './proficiency-range.js'

export function averageSubtopicMastery(
  subtopics: ReadonlyArray<{ mastery: number; isEnabled?: boolean }>,
): number {
  const enabled = subtopics.filter((s) => s.isEnabled !== false)
  if (enabled.length === 0) return 0
  const sum = enabled.reduce((acc, s) => acc + s.mastery, 0)
  return Math.round(sum / enabled.length)
}

/**
 * A topic's mastery: the `rollupWeight`-weighted average of the effective
 * mastery of its enabled subtopics.
 *
 * The one definition of the rule. The coach's admin views reach it through
 * `rollUpTopicMastery` (which layers the topic's plan-inclusion switch on
 * top); the learner's dashboard map reaches it through `buildMasteryPath`.
 * A second copy on either side is how the two views start disagreeing.
 */
export function rollUpSubtopicMastery(
  subtopics: ReadonlyArray<{
    effectiveMastery: number
    isEnabled?: boolean
    rollupWeight?: number
  }>,
): number {
  return weightedAverage(
    subtopics
      .filter((st) => st.isEnabled !== false)
      .map((st) => ({
        value: st.effectiveMastery,
        weight: st.rollupWeight ?? DEFAULT_ROLLUP_WEIGHT,
      })),
  )
}
